import type { Environment } from 'Modules/environment';

export type Language = 'fr' | 'en';
export type IndexOptions = {
  language: Language;
  environment: Environment;
};
export type IndexType =
  | 'jobPostings-by-createdAt'
  | 'jobPostings-by-ranking'
  | 'learning-content'
  | 'learning-content-by-popularity'
  | 'learning-content-by-apprenticeship-business-popularity'
  | 'talents-by-idealStartDate'
  | 'talents-by-displayName'
  | 'talents-by-updatedAt'
  | 'talents-by-createdAt'
  | 'talentsAnonymized-by-updatedAt'
  | 'mentors';

export type IndexName<Type extends IndexType = IndexType> =
  `${Uppercase<Environment>}_${Type}_${Uppercase<Language>}`;

export type DefaultFilters = {
  refinementList?: Record<string, string | string[]>;
  menu?: Record<string, string>;
  geoSearch?: string[];
  numericMenu?: Record<string, string>;
};

function fixEnvMisconfiguration(environment: string, type: string) {
  let fixedEnv = environment;

  if (environment === 'STAGE' && type.startsWith('learning-content')) {
    // FIXME: for some indexes, we need to use STAGE-1 instead of STAGE
    fixedEnv = 'STAGE-1';
  }
  if (environment === 'PREPROD') {
    // FIXME: Preprod environment doesn't exists on Algolia yet so we need to display stage results instead
    return 'STAGE';
  }

  return fixedEnv as Uppercase<Environment>;
}

export default function getIndexName(
  type: IndexType,
  options: IndexOptions = { environment: 'dev', language: 'en' }
): IndexName {
  let environment = options.environment.toUpperCase() as Uppercase<Environment>;

  environment = fixEnvMisconfiguration(environment, type);

  const language = options.language.toUpperCase() as Uppercase<Language>;

  return `${environment}_${type}_${language}`;
}
